<p-table #dt [value]="searchResults" [columns]="cols" responsiveLayout="scroll" [rows]="30" [paginator]="true" [scrollable]="true"
    [rowsPerPageOptions]="[30,60,90]" [showCurrentPageReport]="true" (onPage)="onPageChanged($event)" scrollHeight="800px"
     [(selection)]="selectedResults" *ngIf="searchResults"
    selectionMode="multiple" [rowHover]="true" dataKey="firstSeen" [tableStyle]="{ 'min-width': '200rem' }"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
    <ng-template pTemplate="emptymessage">
        <p class="flex align-items-center justify-content-center p-3 text-lg font-medium no-results-message">No Results Available</p>
    </ng-template>
    <ng-template pTemplate="caption">
        <ng-content></ng-content>
    </ng-template>
    <ng-template pTemplate="header">
        <tr class="sticky-header">
            <th pSortableColumn="urlFrom" pTooltip="{{'components.backlinksResult.referringPageTooltip' | translate}}">{{'components.backlinksResult.referringPageHeader' | translate}}</th>
            <th pSortableColumn="pageFromRank" pTooltip="{{'components.backlinksResult.rankTooltip' | translate}}">{{'components.backlinksResult.rankHeader' | translate}}</th>
            <th pSortableColumn="domainFromRank" pTooltip="{{'components.backlinksResult.domainRankTooltip' | translate}}">{{'components.backlinksResult.domainFromRank' | translate}}</th>
            <th pSortableColumn="rank" pTooltip="{{'components.backlinksResult.linkRankTooltip' | translate}}">{{'components.backlinksResult.linkRank' | translate}}</th>
            <th pSortableColumn="urlTo" class="text-left" pTooltip="{{'components.backlinksResult.targetUrlTooltip' | translate}}">{{'components.backlinksResult.targetUrl' | translate}}</th>
            <th pSortableColumn="pageFromExternalLinks" pTooltip="{{'components.backlinksResult.externalLinksTooltip' | translate}}">{{'components.backlinksResult.externalLinksHeader' | translate}}</th>
            <th pSortableColumn="isNew" pTooltip="{{'components.backlinksResult.newTooltip' | translate}}">{{'components.backlinksResult.newHeader' | translate}}</th>
            <th pSortableColumn="isBroken" pTooltip="{{'components.backlinksResult.brokenTooltip' | translate}}">{{'components.backlinksResult.brokenHeader' | translate}}</th>
            <th pSortableColumn="location" class="text-left">Location</th>
            <th pSortableColumn="anchor" class="text-left" pTooltip="{{'components.backlinksResult.anchorTooltip' | translate}}">{{'components.backlinksResult.anchorHeader' | translate}}</th>
            <th pSortableColumn="dofollow" pTooltip="{{'components.backlinksResult.dofollowTooltip' | translate}}">{{'components.backlinksResult.doFollowHeader' | translate}}</th>
            <th pSortableColumn="firstSeen" pTooltip="{{'components.backlinksResult.firstSeenTooltip' | translate}}">{{'components.backlinksResult.firstSeenHeader' | translate}}</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-result>
        <tr>
            <td style="width:16%;">
                <p *ngIf="result?.pageFromTitle">{{result?.pageFromTitle}}</p>
                <a target="_blank" [href]="result?.urlFrom" [pTooltip]="result?.urlFrom">{{result?.urlFrom | truncate: 50}}</a>
                <p class="flex justify-content-center align-items-center h-2rem w-3rem border-round p-1 mt-2"
                [ngClass]="{'status-code-success': result?.pageFromStatusCode == 200,
                'status-code-error': (result?.pageFromStatusCode == 400 || result?.pageFromStatusCode == 404 || result?.pageFromStatusCode == 500),
                'status-code-warning': result?.pageFromStatusCode == 301}">
                    {{result?.pageFromStatusCode}}
                </p>
            </td>
            <td style="width:6%;">
                {{result?.pageFromRank | number:'1.0':'en-US'}}
            </td>
            <td style="width:6%;">
                {{result?.domainFromRank | number:'1.0':'en-US'}}
            </td>
            <td style="width:6%;">
                {{result?.rank | number:'1.0':'en-US'}}
            </td>
            <td class="text-left" style="width:17%;">
                <a target="_blank" [href]="result?.urlTo" [pTooltip]="result?.urlTo">{{result?.urlTo | truncate: 50}}</a>
                <p class="flex justify-content-center align-items-center h-2rem w-3rem border-round p-1 mt-2"
                [ngClass]="{'status-code-success': result?.urlToStatusCode == 200,
                'status-code-error': (result?.urlToStatusCode == 400 || result?.urlToStatusCode == 404 || result?.urlToStatusCode == 403 || result?.urlToStatusCode == 500),
                'status-code-warning': result?.urlToStatusCode == 301}">
                    {{result?.urlToStatusCode}}
                </p>
            </td>
            <td style="width:6%;">
                {{result?.pageFromExternalLinks | number:'1.0':'en-US'}}
            </td>
            <td style="width:6%;">
                {{result?.isNew ? 'Yes' : 'No'}}
            </td>
            <td style="width:6%;">
                {{result?.isBroken ? 'Yes' : 'No'}}
            </td>
            <td class="text-left" style="width:10%;">
                <span [pTooltip]="result?.semanticLocation">{{result?.semanticLocation ?? 'N/A' | truncate: 25}}</span>
            </td>
            <td class="text-left" style="width:10%;">
                <span [pTooltip]="result?.anchor">{{result?.anchor ?? 'N/A' | truncate: 25}}</span>
            </td>
            <td style="width:6%;">
                {{result?.dofollow ? 'Yes' : 'No'}}
            </td>
            <td style="width:15%;">
                <span>{{result?.firstSeen | date:'shortDate'}}</span> - <span>{{result?.lastSeen | date: 'shortDate'}}</span>
            </td>
        </tr>
    </ng-template>
</p-table>
